import React, { useEffect } from "react"
import * as style from "../styles/Game.module.scss"

export default function Game(props: any) {
    const [url, setUrl] = React.useState(props.url)
    const [width, setWidth] = React.useState(props.width)
    const [height, setHeight] = React.useState(props.height)
    let scale = 1.0

    useEffect(() => {
        function handleResize() {
            const game = document.getElementsByClassName(style.game)[0] as HTMLElement
            const newScale = window.innerWidth / game.clientWidth
            if (newScale > 1) scale = 1
            else scale = newScale

            game.style.transform = `scale(${scale})`
            game.style.marginRight = `-${width - width * scale}px`
            game.style.marginBottom = `${-(height - height * scale) + 60}px`
        }
        handleResize()
        window.addEventListener("resize", handleResize)
    }, [])

    return (
        <div className={style.game}>
            <iframe src={url} width={width} height={height}></iframe>
        </div>
    )
}